// removed by extract-text-webpack-plugin
module.exports = {"Order":"Order__Order__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/Order.css
// module id = 110
// module chunks = 0